<p-inputOtp
  [formControl]="ctrl"
  [mask]="formField?.mask || false"
  [id]="formField.name"
  [length]="4"
  [integerOnly]="true"
/>
